import React from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { setDrawerOpen } from '../../store/global';
import { getStoredAuthUser, isUniverseAdminForItem } from '../../utils/auth';
import { getCanUseMjForDisplayItem } from '../../utils/permissions';
import { Link, useNavigate } from 'react-router-dom';
import { FaChevronRight } from 'react-icons/fa';
import { TooltipHtml } from '../tooltip/tooltip.Html';
import { getAvatarBackgroundStyle, getItemPicAsset } from '../../utils/item';
import { renderIconBySlug } from '../../content/icons';

export const NavigationDisplayItems = props => {
  const { big, displayItem, navigateOnClick = false, hideChevron = false } = props;

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const relatedItems = useSelector(
    state => {
      const mapped = {};
      const ids = [
        displayItem?._id,
        displayItem?.campaign,
        displayItem?.world,
        displayItem?.universe,
      ].filter(Boolean);
      ids.forEach(id => {
        if (state.items[id]) {
          mapped[id] = state.items[id];
        }
      });
      return mapped;
    },
    shallowEqual
  );
  const isTouch = useSelector(state => state.global.isTouch);
  const authUser = getStoredAuthUser();
  const authUserId = authUser?._id;
  const hasUniverseAdmin = isUniverseAdminForItem(
    displayItem,
    relatedItems,
    authUserId
  );
  const canMj = getCanUseMjForDisplayItem({
    item: displayItem,
    items: relatedItems,
    isUniverseAdmin: hasUniverseAdmin,
  });

  if (displayItem?.type === 'tab') {
    return null;
  }

  return (
    <TooltipHtml
      title={displayItem?.alias}
      placement='left'
    >
      <div
        className={`flex items-center w-full gap-05 cursor-pointer ${
          big ? 'py-1' : 'py-05'
        } pl-1 pr-05 transition hover:opacity-50 hover:bg-main-d`}
        draggable={!isTouch}
        onDragStart={event => {
          if (isTouch) return;
          const payload = {
            type: 'item',
            itemId: displayItem?._id,
            sourceFilterId: null,
          };
          const serialized = JSON.stringify(payload);
          window.__estynossDragPayload = payload;
          event.dataTransfer.setData(
            'application/x-estynoss-item',
            serialized
          );
          event.dataTransfer.setData('text/plain', serialized);
          event.dataTransfer.effectAllowed = 'move';
          window.__filterDropTargetId = null;
        }}
        onDragEnd={() => {
          window.setTimeout(() => {
            window.__estynossDragPayload = null;
          }, 150);
        }}
        onClick={() => {
          if (navigateOnClick) {
            navigate(`../../item/${displayItem?._id}`);
            return;
          }
          dispatch(setDrawerOpen(displayItem?._id));
        }}
        key={displayItem?._id}
      >
        {(() => {
          const avatarAsset = getItemPicAsset(displayItem, 0);
          if (avatarAsset.iconSlug) {
            return (
              <div
                className='rounded-full shadow-lg flex items-center justify-center'
                style={{
                  height: big ? 35 : 20,
                  width: big ? 35 : 20,
                  ...getAvatarBackgroundStyle(avatarAsset.bgColor),
                }}
              >
                {renderIconBySlug(avatarAsset.iconSlug, {
                  size: big ? 22 : 16,
                  color: 'var(--contrast)',
                })}
              </div>
            );
          }
          if (avatarAsset.url) {
            return (
              <div
                className='rounded-full shadow-lg'
                style={{
                  height: big ? 35 : 20,
                  width: big ? 35 : 20,
                  ...getAvatarBackgroundStyle(avatarAsset.bgColor),
                  background: `url(${avatarAsset.url}) no-repeat center / cover`,
                }}
              ></div>
            );
          }
          return null;
        })()}

        <div
          className={`flex-1 ${
            big ? '' : 'text-sm'
          } text-contrast text-opacity-75`}
        >
          {displayItem?.label}
        </div>
        {canMj && !hideChevron && (
          <Link
            to={`../../item/${displayItem?._id}`}
            className='flex justify-end cursor-pointer transition hover:opacity-50'
          >
            <FaChevronRight size={12} />
          </Link>
        )}
      </div>
    </TooltipHtml>
  );
};
